module.exports = __webpack_public_path__ + "img/score_shock.66b6d050.png";